
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"3","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.852 2.438a.91.91 0 01-.68-.282 1.016 1.016 0 01-.274-.726c0-.292.092-.532.274-.72a.898.898 0 01.68-.288c.27 0 .497.096.68.289a.988.988 0 01.273.719c0 .291-.091.534-.274.726a.91.91 0 01-.68.281zm-4.735 0a.91.91 0 01-.68-.282 1.016 1.016 0 01-.273-.726c0-.292.091-.532.273-.72a.898.898 0 01.68-.288c.271 0 .498.096.68.289a.988.988 0 01.273.719c0 .291-.09.534-.273.726a.91.91 0 01-.68.281zm9.469 0a.91.91 0 01-.68-.282 1.016 1.016 0 01-.273-.726c0-.292.091-.532.273-.72a.897.897 0 01.68-.288c.27 0 .497.096.68.289a.988.988 0 01.273.719c0 .291-.091.534-.273.726a.91.91 0 01-.68.281z","fill":"currentColor"}})])
          )
        }
      }
    